export default __webpack_public_path__ + "static/media/back.edf56d63.svg";